import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SignatureBox from 'components/SignatureBox';
import CheckBox from 'components/CheckBox';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../reducers';

class CustomerSignature extends Resetter(Validator(React.Component)) {
  state = {
    customerSignature: this.props.customerSignature || '',
    clearCustomerSignature: 0,
    errors: {},
    customerApprovedSignature: this.props.customerApprovedSignature || false,
  };

  customerSignatureRef = React.createRef();

  componentDidMount = () => this.customerSignatureRef.current.scrollIntoView(false);

  handleSubmit = () => {
    const { customerSignature, customerApprovedSignature } = this.state;
    this.props.updateFormData({
      customerSignature,
      customerApprovedSignature,
      tab: 8,
    });
  }

  handlePrevious = () => {
    const { customerSignature } = this.state;
    this.props.updateFormData({
      customerSignature,
      customerApprovedSignature: this.state.customerApprovedSignature,
      tab: 6,
    });
  }

  handleCustomerSignature = data => this.setState({ customerSignature: data });

  handleCustomerClear = () => {
    this.setState({
      customerSignature: '',
      clearCustomerSignature: this.props.customerSignature
        ? this.state.clearCustomerSignature : Date.now(),
    });
    this.props.updateFormData({ contractorSignature: '' });
  }

  handleCustomerApprovedSignature = () => this.setState({
    customerApprovedSignature: !this.state.customerApprovedSignature, customerSignature: '',
  });

  render = () => {
    const { isSpanish, customerSignature } = this.props;
    const {
      errors,
      clearCustomerSignature,
      customerApprovedSignature,
    } = this.state;

    return (<div ref={this.customerSignatureRef}>
      <h6>
        {isSpanish ? 'Firma del cliente' : 'Customer Signature'}
      </h6>
      <CheckBox
        label="Customer Approved Signature"
        required
        text="Customer verified complete, no signature due to COVID-19"
        errors={errors.approveTerms}
        onChange={this.handleCustomerApprovedSignature}
        checked={this.state.customerApprovedSignature}
      />
      { !customerApprovedSignature && <SignatureBox
        label={isSpanish
          ? 'Firmar el nombre del cliente*'
          : 'Sign Customer\'s Name*'
        }
        required
        value={customerSignature}
        errors={errors.customerSignature}
        clearTimestamp={clearCustomerSignature}
        onEnd={this.handleCustomerSignature}
        onClear={this.handleCustomerClear}
      /> }
      <Button
        label={isSpanish ? 'Completar' : 'Complete'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <Button
        label={isSpanish ? 'Anterior' : 'Previous'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handlePrevious}
      />
    </div>);
  }
}

CustomerSignature.propTypes = {
  isSpanish: PropTypes.bool,
  customerSignature: PropTypes.string,
  errors: PropTypes.shape({
    customerSignature: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(CustomerSignature);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/customerSignature.jsx